<template>
    <div id="review">
        <h2>Uw Review <loader v-if="isLoading" width="2rem"></loader></h2>
        <form v-on:submit.prevent="submitReview">
            <div class="text-center mb-5 mt-5">
                <score size="fa-5x" :score="review.rating" :showQty="false" :disabled="locked" @update="setRating"></score>
            </div>
            <div class="form-group">
                <label for="report" class="form-label">Publieke Review</label>
                <textarea type="text" class="form-control" id="report" rows="10" placeholder="Hoe beoordeel je deze opdracht? Deze informatie wordt gedeeld..."  v-model="review.publicReview"  :disabled="locked"></textarea>
            </div>
            <div class="form-group">
                <label for="report" class="form-label">Privé bericht</label>
                <textarea type="text" class="form-control" id="report" rows="5" placeholder="Type hier het bericht dat u met de opdrachtgever wilt delen..."  v-model="review.privateReview"  :disabled="locked"></textarea>
                <small>Dit bericht wordt alleen met de opdrachtgever gedeeld en zal niet publiekelijk zichtbaar zijn.</small>
            </div>
            <div class="form-group text-right">
                <loader v-if="isLoading" width="2rem"></loader>
                <button type="button" class="btn" @click="clearReview" :disabled="locked">Leegmaken</button>
                <button type="submit" class="btn btn-azure-dark" :disabled="locked">Versturen</button>
            </div>
        </form>
    </div>
</template>

<script>
import { review } from '@/models/models.js';
import Score from '@/components/Score';
import Loader from '@/components/Loader';

export default 
{
    props: {
        to: {
            required: false,
            type: Number
        }
    },
    components: {
        Score,
        Loader
    },
    data() {
        return {
            review: {},
            isLoading: false,
            locked: false
        }
    },
    mounted() {
        if(this.assignment)
            this.getReview();
    },
    methods: {
        getReview() {
            this.isLoading = true; 
            this.$http.get('api/Review/' + this.assignment.id).then((res) => {
                this.isLoading = false; 
                if(res.data)
                {
                    this.review = new review(res.data);
                    this.locked = true;
                } else {
                    this.review =new review({ assignmentId: this.assignment.id, toId: this.to })
                }
            });
        },
        setRating(rate) {
            this.review.rating = rate;
        },
        submitReview() {
            if(!this.locked)
            {
                this.locked = true;   
                this.isLoading = true; 
                if(this.to != null)
                    this.review.toId = this.to;

                this.$http.post('api/Review', this.review).then((res) => {
                    this.review = new review(res.data);
                    this.isLoading = false; 
                }).catch(() => { 
                    this.isLoading = false; 
                    this.locked = false 
                });
            }
        },
        clearReview() {
            if(!this.locked)
                return this.review = new review({ assignmentId: this.assignment.id, toId: this.to });
        }
    },
    computed: {
        assignment() {
            return this.$parent.assignment;
        }
    },
    watch: {
        assignment(to) {
            if(to.id)
            {
                this.getReview();
            }
        }
    }
}
</script>